import script from "./SingleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleTab.vue?vue&type=script&setup=true&lang=js"

import "./SingleTab.vue?vue&type=style&index=0&id=5b60aada&scoped=true&lang=scss"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b60aada"]])

export default __exports__